










































































































































































































































import Vue from 'vue'
import { DataTableHeader } from 'vuetify/types'
import { getNestedValue } from '@/util/helpers'
import { BuildingType } from '../../interfaces/valuation/types/BuildingValuationStep'

interface DataOptions {
  loading: boolean
  soldPage: number
  soldPageCount: number
  soldItemsPerPage: number
  freePage: number
  freePageCount: number
  freeItemsPerPage: number
  headers: DataTableHeader[]
}

export default Vue.extend({
  props: {
    valuationNumber: {
      type: String,
      required: true,
    },
  },
  created() {
    this.loading = true
    this.$store
      .dispatch('valuationEdit/fetchOffersData', this.valuationNumber)
      .finally(() => (this.loading = false))
  },
  data(): DataOptions {
    return {
      loading: false,
      soldPage: 1,
      soldPageCount: 0,
      soldItemsPerPage: 10,
      freePage: 1,
      freePageCount: 0,
      freeItemsPerPage: 10,
      headers: [
        {
          text: 'Název projektu',
          value: 'projectName',
          sortable: false,
        },
        {
          text: 'Developer',
          value: 'developerDesc',
          sortable: false,
        },
        {
          text: 'Okres/obvod',
          value: 'districtDesc',
          sortable: false,
        },
        {
          text: 'Správní obvod',
          value: 'landAreaDesc',
          sortable: false,
        },
        {
          text: 'Městská část',
          value: 'municipalityDesc',
          sortable: false,
        },
        {
          text: 'Celkem bytů',
          value: 'totalUnits',
          sortable: false,
          align: 'center',
        },
      ],
    }
  },
  computed: {
    unitsSoldHeaders(): DataTableHeader[] {
      return [
        ...this.headers,
        {
          text: 'Počet prodaných bytů',
          value: 'freeUnits',
          sortable: false,
          align: 'center',
        },
      ]
    },
    unitsSold(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/offersData'],
        ['unitsSold'],
        []
      )
    },
    unitsSoldProjects(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/offersData'],
        ['unitsSoldProjects'],
        []
      ).map((project: any) => {
        const freeUnits = getNestedValue(project, ['freeUnits'], 0)
        const totalUnits = getNestedValue(project, ['totalUnits'], 0)
        project.freeUnits = totalUnits - freeUnits
        return project
      })
    },
    unitsFreeHeaders(): DataTableHeader[] {
      return [
        ...this.headers,
        {
          text: 'Počet volných bytů',
          value: 'freeUnits',
          sortable: false,
          align: 'center',
        },
      ]
    },
    unitsFree(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/offersData'],
        ['unitsFree'],
        []
      )
    },
    unitsFreeProjects(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/offersData'],
        ['unitsFreeProjects'],
        []
      )
    },
    buildingType(): string {
      return this.$store.getters['valuationEdit/buildingType']
    },
    isBuildingTypeNew(): boolean {
      return this.buildingType === BuildingType.New
    },
  },
})
